import { Children, FC } from 'react';
import { AllieFadeInContainerProps } from './FadeInContainer.types';
import { Container, AnimatedItem } from './FadeInContainer.styles';

/**
 * Componente genérico para contenedores con animación fade-in
 * Soporta múltiples tipos de layout: grid, flex, block, etc.
 */
export const AllieFadeInContainer: FC<AllieFadeInContainerProps> = ({
  children,
  layout = 'grid',
  gap = '16px',
  gridConfig = { columns: 3 },
  flexConfig,
  animationType = 'fadeUp',
  animationDuration = '0.5s',
  animationDelay = 100,
  preserveChildrenStructure = false,
  className,
  style,
}) => {
  const childrenArray = Children.toArray(children);

  // Auto-detectar si necesitamos preservar la estructura del layout
  const shouldPreserveLayout = Boolean(
    preserveChildrenStructure || 
    (layout === 'grid' && gridConfig?.templateAreas)
  );

  return (
    <Container
      layout={layout}
      gap={gap}
      gridConfig={gridConfig}
      flexConfig={flexConfig}
      className={className}
      style={style}
    >
      {childrenArray.map((child, index) => (
        <AnimatedItem
          key={index}
          animationDuration={animationDuration}
          delay={index * animationDelay}
          preserveLayout={shouldPreserveLayout}
          animationType={animationType}
        >
          {child}
        </AnimatedItem>
      ))}
    </Container>
  );
};
